import PropTypes from "prop-types";

import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";

// Rendered inside the detail page's tab panel, so it carries no Paper or
// heading of its own.
export const ExpensesSection = ({ salesReturnExpenses = [] }) => {
  const columns = [
    {
      field: "outletChartOfAccount",
      headerName: "Akun",
      flex: 3,
      valueGetter: (value, row) => {
        const account = row.outletChartOfAccount;
        return account ? `${account.code} - ${account.name}` : "";
      },
    },
    {
      field: "amount",
      headerName: "Nominal",
      flex: 1,
      type: "number",
      valueFormatter: (value) => formatNumber(value),
    },
    {
      field: "note",
      headerName: "Catatan",
      flex: 2,
      valueGetter: (_, row) => row.note || "-",
    },
  ];

  return (
    // No auto row height: every cell here is single-line, and auto would
    // shrink the rows well below the invoice tabs they sit beside.
    <DataGrid
      columns={columns}
      rows={salesReturnExpenses}
      disableRowSelectionOnClick
      hideFooter
    />
  );
};

ExpensesSection.propTypes = {
  salesReturnExpenses: PropTypes.array,
};
